import { useContext } from 'react';
import clsx from 'clsx';

import { Icon } from '@atom/mui';
import colors from '@atom/styles/colors';

import BulkContext, { Tab } from '../BulkContext';

import classes from './step.module.css';

export interface Props {
  currentTab: Tab;
  tab: Tab;
}

const Step = ({ currentTab, tab }: Props) => {
  const { invalidTabs, setTab } = useContext(BulkContext);
  const isInvalid = invalidTabs.has(tab.id);
  const isActive = currentTab.value === tab.value;
  const iconColor = isActive ? colors.utility.activeBlue : colors.neutral.gray;

  const onStepClick = () => setTab(tab);

  return (
    <div
      className={clsx(classes.step, isActive && classes.stepActive)}
      onClick={onStepClick}
    >
      {isInvalid ? (
        <Icon color={colors.brand.red}>error</Icon>
      ) : (
        <Icon color={iconColor}>{tab.icon}</Icon>
      )}
      <div className={classes.stepTitleContainer}>
        <div
          className={clsx(
            classes.stepTitle,
            isActive && classes.active,
            isInvalid && classes.invalid,
          )}
        >
          {tab.label}
        </div>
        {tab.subText && (
          <div
            className={clsx(
              classes.stepSubtext,
              isActive && classes.active,
              isInvalid && classes.invalid,
            )}
          >
            {tab.subText}
          </div>
        )}
      </div>
    </div>
  );
};

export default Step;
